/**
 * Identity of a stripes-core ky instance: the okapi settings `useOkapiKy`
 * builds it from. Two equal keys mean an equivalent instance.
 */
export var okapiKyKey = function (okapi, tenantOverride) {
    return JSON.stringify([
        okapi === null || okapi === void 0 ? void 0 : okapi.url,
        tenantOverride !== null && tenantOverride !== void 0 ? tenantOverride : okapi === null || okapi === void 0 ? void 0 : okapi.tenant,
        okapi === null || okapi === void 0 ? void 0 : okapi.token,
        okapi === null || okapi === void 0 ? void 0 : okapi.locale,
        okapi === null || okapi === void 0 ? void 0 : okapi.timeout,
    ]);
};
